import { Box, Typography } from '@mui/material';
import AurSvgIcon from '../../common/aur-svg-icon/AurSvgIcon';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';

const EcaDocumentSummary = () => {
  const truncatedBannerText = useSelector(
    (state: RootState) => state.ecaDocumentViewer.truncatedBannerText
  );

  return (
  <div> {truncatedBannerText ? (
    <Box 
    className="eca-document-summary-container" 
    role="alert" tabIndex={0}>
      <AurSvgIcon src="images/eca-doc-summary-icon.svg" />
      <Typography className="summary-text">
        {t('ecaDocList.summaryText')}
      </Typography>
    </Box>
  ) : null
  }
  </div>)
};

export default EcaDocumentSummary;